import React, { CSSProperties } from 'react';
import { ModalBody, DatePicker, FormCheckbox, FormGroup, FormInput, FormTextarea, InputGroup, InputGroupAddon, InputGroupText } from 'shards-react';

interface ModalEditBodyProps {
  // order
  labelOrder: string;
  order: number;
  invalidOrder: boolean;
  onChangeOrder: (event: React.ChangeEvent<{ value: number }>) => void;

  // title
  labelTitle: string;
  title: string;
  invalidTitle: boolean;
  onChangeTitle: (event: React.ChangeEvent<{ value: string }>) => void;

  // message
  labelMessage: string;
  message: string;
  invalidMessage: boolean;
  onChangeMessage: (event: React.ChangeEvent<{ value: string }>) => void;

  // startDate
  labelStartDate: string;
  selectedStartDate: Date;
  styleStartDate: CSSProperties;
  minStartDate: Date;
  maxStartDate: Date | null;
  onChangeStartDate: (Date) => void;

  // endDate
  labelEndDate: string;
  selectedEndDate: Date;
  styleEndDate: CSSProperties;
  minEndDate: Date;
  onChangeEndDate: (Date) => void;

  // draft
  labelDraft: string;
  checked: boolean;
  onToggleDraft: () => void;
}

const ModalEditBody = ({
  // order
  labelOrder,
  order,
  invalidOrder,
  onChangeOrder,

  // title
  labelTitle,
  title,
  invalidTitle,
  onChangeTitle,

  // message
  labelMessage,
  message,
  invalidMessage,
  onChangeMessage,

  // startDate
  labelStartDate,
  selectedStartDate,
  styleStartDate,
  minStartDate,
  maxStartDate,
  onChangeStartDate,

  // endDate
  labelEndDate,
  selectedEndDate,
  styleEndDate,
  minEndDate,
  onChangeEndDate,

  // draft
  labelDraft,
  checked,
  onToggleDraft,
}: ModalEditBodyProps): React.ReactElement => {
  // SIDE EFFECT
  // ================================================================================

  /**
   * 確認用
   */
  // useEffect(() => {
  //   console.log(d);
  // }, [d]);

  // EVENT HANDLER
  // ================================================================================

  // VIEW
  // ================================================================================

  return (
    <ModalBody>
      <FormGroup>
        <label htmlFor="corder">{labelOrder}</label>
        <FormInput id="order" type="number" className="mb-3" value={order} invalid={invalidOrder} onChange={onChangeOrder} />
      </FormGroup>
      <FormGroup>
        <label htmlFor="title">{labelTitle}</label>
        <FormInput id="title" className="mb-3" value={title} invalid={invalidTitle} onChange={onChangeTitle} />
      </FormGroup>
      <FormGroup>
        <label htmlFor="text">{labelMessage}</label>
        <FormTextarea id="text" className="mb-3" rows={4} value={message} invalid={invalidMessage} onChange={onChangeMessage} />
      </FormGroup>
      <InputGroup className="mb-3">
        <InputGroupAddon type="prepend">
          <InputGroupText>{labelStartDate}</InputGroupText>
        </InputGroupAddon>
        <InputGroupAddon type="append" style={styleStartDate}>
          <DatePicker
            showTimeSelect
            selected={selectedStartDate}
            minDate={minStartDate}
            maxDate={maxStartDate}
            onChange={onChangeStartDate}
            placeholderText="Select Start Date Time"
            dropdownMode="select"
            dateFormat="yyyy-MM-dd hh:mm:ss"
            className="text-center"
          />
        </InputGroupAddon>
      </InputGroup>
      <InputGroup className="mb-3">
        <InputGroupAddon type="prepend">
          <InputGroupText>{labelEndDate}</InputGroupText>
        </InputGroupAddon>
        <InputGroupAddon type="append" style={styleEndDate}>
          <DatePicker
            showTimeSelect
            selected={selectedEndDate}
            minDate={minEndDate}
            onChange={onChangeEndDate}
            placeholderText="Select End Date Time"
            dropdownMode="select"
            dateFormat="yyyy-MM-dd hh:mm:ss"
            className="text-center"
          />
        </InputGroupAddon>
      </InputGroup>
      <FormCheckbox checked={checked} onChange={onToggleDraft}>
        {labelDraft}
      </FormCheckbox>
    </ModalBody>
  );
};

export default ModalEditBody;
